export interface Point {
    id?: string;
    display_labels: {[k: string]: string};
    alternate_ids: {SOURCE_ID: string};
    reporting_interval_ms: number;
}

export class Point implements Point{}
